import { useCallback, useState } from 'react';

import type { AnyFormat } from './types';

export interface AsyncExportState {
  variantId: string;
  exportId: string;
  jobId?: string;
  format?: AnyFormat;
}

export interface DownloadController {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  asyncExport: AsyncExportState | null;
  startAsync: (payload: AsyncExportState) => void;
  dismissProgress: () => void;
}

export const useDownloadController = (): DownloadController => {
  const [isOpen, setIsOpen] = useState(false);
  const [asyncExport, setAsyncExport] = useState<AsyncExportState | null>(null);

  return {
    isOpen,
    open: useCallback(() => setIsOpen(true), []),
    close: useCallback(() => setIsOpen(false), []),
    asyncExport,
    startAsync: useCallback((payload: AsyncExportState) => setAsyncExport(payload), []),
    dismissProgress: useCallback(() => setAsyncExport(null), []),
  };
};
